module.exports = __webpack_public_path__ + "img/bg-mobile.7c72848.webp";